export const ItemTypes = {
  MARK: "mark",
  PAGE: "page",
}
